import { httpApi } from '@app/api/http.api';
import {
  Menu,
  CreateMenuDto,
  UpdateMenuDto,
} from '@app/types/api.types';

export const createMenu = (data: CreateMenuDto): Promise<Menu> =>
  httpApi.post<Menu>('/menus', data).then(({ data }) => data);

export const getMenus = (): Promise<Menu[]> =>
  httpApi.get<Menu[]>('/menus').then(({ data }) => data);

export const getMenusNested = (): Promise<Menu[]> =>
  httpApi.get<Menu[]>('/menus/nested').then(({ data }) => data);

export const getMenuById = (id: string): Promise<Menu> =>
  httpApi.get<Menu>(`/menus/${id}`).then(({ data }) => data);

export const updateMenu = (id: string, data: UpdateMenuDto): Promise<Menu> =>
  httpApi.patch<Menu>(`/menus/${id}`, data).then(({ data }) => data);

export const deleteMenu = (id: string): Promise<void> =>
  httpApi.delete<void>(`/menus/${id}`).then(() => undefined);

export const deleteMenuCascade = (id: string): Promise<void> =>
  httpApi.delete<void>(`/menus/${id}/cascade`).then(() => undefined);

// Public endpoints
export const getPublicMenus = (): Promise<Menu[]> =>
  httpApi.get<Menu[]>('/public/menus').then(({ data }) => data);

export const getPublicMenusAll = (): Promise<Menu[]> =>
  httpApi.get<Menu[]>('/public/menus/all').then(({ data }) => data);

